import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'
import { useEvaluationStore } from './useEvaluationStore'

export const useInfraStore = defineStore('infra', () => {
  const evaluationStore = useEvaluationStore()

  const infra = ref({
    kauplus: '',
    kool: '',
    lasteaed: '',
    yhistransport: '',
    haigla: '',
    suurhaigla: '',
    rand: '',
    supluskoht: '',
    ujula: '',
    toostusala: '',
    kalmistu: '',
    spordirajatis: '',
    vangla: '',
    politseijaam: '',
    toitlustus: '',
    juurdepaas: '',
    parkimine_ymbruses: '',
    haljastus: '',
    veekogud_ymbruses: '',
    saastatus: '',
    kergliiklus: '',
    konkureeriv_turupiirkond: '',
    piirkonna_hoonestus: '',
    asukoha_kirjeldus: '',
  })

  const closestInfra = params => {
    return new Promise(async (resolve, reject) => {
      const categoryMap = {
        shop: 'kauplus',
        school: 'kool',
        kindergarden: 'lasteaed',
        public_transportation_stop: 'yhistransport',
        hospital: 'haigla',
        medical_center: 'suurhaigla',
        beach: 'rand',
        swimming_area: 'supluskoht',
        swimming_pool: 'ujula',
        industrial: 'toostusala',
        cemetery: 'kalmistu',
        sports_facility: 'spordirajatis',
        prison: 'vangla',
        police: 'politseijaam',
        restaurant_cafe: 'toitlustus',
      }

      try {
        const res = await axios.get('/api/poi/closest', { params })

        const result = res.data.result
        const formattedValue = result
          .map(
            row => `${row.poi.name} - ${Math.round(row.distance)} ${row.unit}`,
          )
          .join(', ')

        infra.value[categoryMap[params.category]] = formattedValue
        resolve()
      } catch (err) {
        console.error('Error: ' + err)
        reject(err)
      }
    })
  }

  const saveInfra = () => {
    evaluationStore.save({ infra: { ...infra.value } })
  }

  const restoreFromSaved = savedData => {
    if (!savedData) return
    Object.entries(savedData).forEach(([key, value]) => {
      if (key in infra.value) {
        infra.value[key] = value ?? ''
      }
    })
  }

  return {
    infra,
    closestInfra,
    saveInfra,
    restoreFromSaved,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useInfraStore, import.meta.hot))
}
